<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Aguarde ...</p>
  </ngx-spinner>
  
  <div class="row">
    <div class="col-12">
      <app-card  [options]="false" [hidHeader]="true">
        <div class="row">
          <div class="col-sm-12 col-xl-4 ">
            <label class="sub-title">Filtro</label>
            <input type="text" class="form-control" [(ngModel)]="filtro">
          </div>
        </div>
  
  
  
      </app-card>
    </div>
    <div class="col-12">
      <app-card cardTitle="Responsável Cadastrado" blockClass="table-border-style" [options]="false">
        <div class="list-group list-group-flush">
          <div class="list-group-item" *ngFor="let item of arrayResponsavel | fullTextSearch:filtro">
            <div class="row">
              <div class="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Nome</small>
                <span class="font-weight-semibold d-block">{{item.nome }}</span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">CPF</small>
                <span class="d-block text-break">{{item.cpf }}</span>
              </div>
              <div class="col-12 col-md-4 col-lg-2 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">RG</small>
                <span class="d-block text-break">{{item.rg }}</span>
              </div>
              <div class="col-12 col-md-6 col-lg-4 mb-3 mb-lg-0">
                <small class="text-uppercase text-muted d-block">Email</small>
                <span class="d-block text-break">{{item.email }}</span>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 col-md-6 col-lg-3 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Cidade</small>
                <span class="d-block text-break">{{item.cidade }}</span>
              </div>
              <div class="col-12 col-md-6 col-lg-2 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Estado</small>
                <span class="d-block text-break">{{item.estado }}</span>
              </div>
              <div class="col-12 col-md-6 col-lg-3 mt-md-0">
                <small class="text-uppercase text-muted d-block">Ações</small>
                <button type="button" class="btn btn-warning btn-sm mt-1" (click)="resetarDispositivo(item)">
                  <i class="fa fa-check"></i> Liberar Dispositivo
                </button>
              </div>
            </div>
          </div>
        </div>
      </app-card>
    </div>
  </div>
  